import React from "react"

export const  Data=[
    {
        heading1:"Purchase theme on Themeforest.net",
        para1:"Start creating your amazing website today!",
        button:"Purchase Theme"
    }
]